import React, { useState } from 'react';
import { Alert, Col, Row } from 'react-bootstrap';
import { Field, getIn, useFormikContext } from 'formik';
import { InsuranceBrokerRemoteSelector } from '../../Shared';
import { AccountRemoteSelector } from '../../InsurancePolicies';
import IconGG from '../../Utils/Icon';
import { IconBtn } from '../../Utils/Button';
import { SimpleCenteredModal } from '../../Utils/Modal';
import AccountModalForm from '../../InsurancePolicies/Forms/AccountModalForm';

const AccountSection = ({ fromAdmin, modelName, userModule }) => {
  const [modalShow, setModalShow] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const { values } = useFormikContext();
  const { insuranceBrokerId } = getIn(values, modelName);

  const handleModalClose = () => setModalShow(false);
  return (
    <>
      <section className="form-section mb-5 w-100 account-section">
        <p className="section-title">Información de la Cuenta</p>

        <Row className="account-section__form">
          {fromAdmin && (
            <Col md={4} lg={4}>
              <Field name={`${modelName}[insuranceBrokerId]`}>
                {({ field }) => (
                  <InsuranceBrokerRemoteSelector
                    fromAdmin={fromAdmin}
                    field={field}
                    modelName={modelName}
                    tooltipText="Usuario Corredor a quien pertenece la Cuenta (Corredor, Partner o Directo)."
                  />
                )}
              </Field>
            </Col>
          )}
          <Col md={4} lg={4}>
            <Field name={`${modelName}[accountId]`}>
              {({ field }) => (
                <AccountRemoteSelector
                  key={refreshKey} // Forzar actualización
                  field={field}
                  modelName={modelName}
                  fromAdmin={fromAdmin}
                  disabled={fromAdmin && !insuranceBrokerId}
                  userModule={userModule}
                />
              )}
            </Field>
          </Col>
          <Col sm={12} md={5} lg={5} className="d-flex align-items-center">
            <Alert variant="warning" className="account-section__alert mb-0">
              <IconGG className="mr-2" icon="danger" size="sm" />
              <p className="detail font-weight-bold">
                Si no encuentras la Cuenta, puedes crear una nueva a continuación.
              </p>
            </Alert>
          </Col>
          <Col sm={12} md={3} lg={3} className="d-flex align-items-center">
            <IconBtn
              icon="add"
              className="mt-lg-0"
              onClick={() => setModalShow(true)} // disabled={onRequest}
              disabled={fromAdmin && !insuranceBrokerId}
            >
              Nueva cuenta
            </IconBtn>
          </Col>
        </Row>

        <SimpleCenteredModal
          size="xl"
          title="Crear nueva cuenta"
          show={modalShow}
          onHide={handleModalClose}
          body={
            <AccountModalForm
              insuranceBrokerId={insuranceBrokerId}
              fromAdmin={fromAdmin}
              handleCancelButton={handleModalClose}
              setRefreshKey={setRefreshKey}
            />
          }
        />
      </section>

      <hr className="w-100 mb-5" />
    </>
  );
};

export default AccountSection;
